// Design tokens thương hiệu "trái bơ bổ đôi" — nguồn sự thật cho UI.
// Theme MD2 (`assets/theme/base/colors.js`, typography.js) và component
// domain đều phải bám các export này; không hard-code hex/font mới trong
// layouts nếu đã có token tương đương.
//
// Xem skill `.claude/skills/thumua-ui-design-system/SKILL.md` khi chuẩn hóa UI.

// ---------------------------------------------------------------------------
// Primitive — bảng màu gốc
// ---------------------------------------------------------------------------
export const MAU = {
  ink: "#1B2417",
  skin: "#1F4029",
  skinDeep: "#132A1A",
  flesh: "#93B15E",
  pit: "#D2A23A",
  paper: "#F7F2E4",
};

/** Xanh lá tương tác (nút/focus) — dẫn xuất từ MAU.skin, đủ contrast chữ trắng. */
export const XANH_LA = {
  main: "#2E6042",
  light: "#3A7852",
  dark: "#245134",
};

// ---------------------------------------------------------------------------
// Semantic — dùng trong JSX qua import, không copy hex
// ---------------------------------------------------------------------------
export const SEMANTIC = {
  // Nền / bề mặt
  background: MAU.paper,
  surface: "#FFFFFF",
  // Chữ
  textPrimary: MAU.ink,
  textSecondary: "#6F6B60",
  textDisabled: "#94A3B8",
  // Viền
  border: "#E5DFD0",
  borderStrong: "#D5D9DD",
  // Trạng thái (map gần MUI success/warning/error/info)
  success: "#2E7D32",
  warning: "#ED6C02",
  error: "#D32F2F",
  /** Cảnh báo/xóa trên form thu mua hiện trường (terracotta) — khác error MUI. */
  danger: "#B3492E",
  info: XANH_LA.main,
  // Hành động chính = xanh lá bơ (không dùng primary hồng MD2 gốc)
  primary: XANH_LA.main,
  primaryHover: XANH_LA.dark,
  accent: MAU.pit,
};

// ---------------------------------------------------------------------------
// Typography
// ---------------------------------------------------------------------------
// FONT_CHU (Inter): thân bài, nhãn, số liệu, nút, ô nhập.
// FONT_HIEU (Fraunces): tiêu đề / thương hiệu — đã nạp trong public/index.html.
export const FONT_CHU = "'Inter', 'Roboto', sans-serif";
export const FONT_HIEU = "'Fraunces', 'Georgia', 'Times New Roman', serif";

/** Scale gợi ý (px) — khi viết sx mới, ưu tiên các bậc này; runtime qua theme.typography. */
export const TYPE_SCALE = {
  display: { size: 32, weight: 700, family: "hieu" },
  h1: { size: 28, weight: 700, family: "hieu" },
  h2: { size: 24, weight: 700, family: "hieu" },
  h3: { size: 20, weight: 600, family: "hieu" },
  h4: { size: 18, weight: 600, family: "chu" },
  bodyLarge: { size: 16, weight: 400, family: "chu" },
  body: { size: 14, weight: 400, family: "chu" },
  bodySmall: { size: 13, weight: 400, family: "chu" },
  caption: { size: 12, weight: 400, family: "chu" },
  overline: { size: 11, weight: 600, family: "chu" },
};

// ---------------------------------------------------------------------------
// Spacing (8px base) + radius
// ---------------------------------------------------------------------------
export const SPACE = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 40,
  8: 48,
  9: 64,
};

export const RADIUS = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  // Ánh xạ component
  input: 8,
  button: 8,
  card: 12,
  dialog: 12,
};

// ---------------------------------------------------------------------------
// Layout chrome
// ---------------------------------------------------------------------------
export const LAYOUT = {
  sidebarWidth: 250,
  sidebarMini: 80,
  headerHeight: 64,
  dialogFormMaxWidth: 960,
  filterSelectWidth: 176, // 11rem — khớp ô ngày trong HangBoLoc
  breakpoints: {
    mobile: 600, // MUI sm
    tablet: 900, // MUI md
    laptop: 1200, // MUI lg / sidenav collapse
    desktop: 1280,
  },
};
